import mitt from 'mitt';
import {createVBusDirective} from './directives/v-bus';
import {createOnBusDirective} from './directives/v-onbus';
import {createPollOnDirective} from './directives/v-poll-on';
import {createRedirectOnDirective} from './directives/v-redirect-on';

class EventSystem {
  constructor() {
    this.emitter = mitt();
  }

  registerDirectives(app) {
    app.directive('bus', createVBusDirective(this.emitter));
    app.directive('onbus', createOnBusDirective(this.emitter));
    app.directive('poll-on', createPollOnDirective(this.emitter));
    app.directive('redirect-on', createRedirectOnDirective(this.emitter));
  }

  install(app) {
    app.config.globalProperties.$bus = this.emitter;
    window.$bus = app.config.globalProperties.$bus;
    this.registerDirectives(app);
  }
}

export const eventSystem = new EventSystem();
export const bus = eventSystem.emitter;
